module.exports = __webpack_public_path__ + "static/media/compte.98c830b2.png";